"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCode = useCode;
exports.useGydra = useGydra;
exports.useExamples = useExamples;
exports.useDebug = useDebug;
const React = __importStar(require("react"));
const dist_1 = __importDefault(require("gydra-synth/dist"));
const clientAPI_1 = __importDefault(require("./server/clientAPI"));
const state_1 = require("./state");
function useCode(key, enabled = true) {
    const state = (0, state_1.getState)();
    const [code, setCode] = React.useState(state[key]);
    React.useEffect(() => {
        if (!enabled)
            return;
        history.pushState(null, null, location.href);
        function storeCode() {
            const code = new URLSearchParams(location.search).get("code");
            if (code) {
                const decoded = decodeURIComponent(atob(code));
                setCode(decoded);
                (0, state_1.setState)({ [key]: decoded });
            }
        }
        function loadCode() {
            const code = new URLSearchParams(location.search).get("code");
            if (code) {
                const decoded = decodeURIComponent(atob(code));
                setCode(decoded);
            }
        }
        loadCode();
        (0, state_1.watchState)(newState => {
            if (newState[key] !== code) {
                setCode(newState[key]);
            }
        });
        window.addEventListener("popstate", loadCode);
        window.addEventListener("pushstate", storeCode);
        return () => {
            window.removeEventListener("popstate", storeCode);
            window.removeEventListener("pushstate", loadCode);
        };
    }, [enabled]);
    const updateCode = React.useCallback((newCode, hush = false) => {
        if (!enabled)
            return;
        // add history
        const codebase64 = btoa(encodeURIComponent(newCode));
        // check if code is too long
        if (codebase64.length < 1800) {
            const url = new URL(location.href);
            url.searchParams.set("code", codebase64);
            history.pushState(null, null, url.toString());
            window.dispatchEvent(new Event("pushstate"));
        }
        else {
            // new event code-update with data all code
            window.dispatchEvent(new CustomEvent("code-update", { detail: { code: newCode, hush } }));
            (0, state_1.setState)({ [key]: newCode });
        }
        // TODO: enable this condition only in live mode
        //if (bEvalAll) {
        //}
    }, [enabled, code]);
    return [code, updateCode];
}
function useGydra(canvas, code = "", options, updateCode) {
    const [synth, setSynth] = React.useState(null);
    const [error, setError] = React.useState(null);
    React.useEffect(() => {
        if (!canvas.current)
            return;
        const settings = Object.assign({ makeGlobal: true, autoTick: true, outputs: 10, canvas: canvas.current, cameraControl: document.getElementById("root"), useWorker: false }, options);
        const newSynth = (0, dist_1.default)(settings);
        newSynth.export("api", clientAPI_1.default);
        //synth.debugger()
        window["gydra"] = newSynth;
        setSynth(newSynth);
        return () => {
            newSynth.stop();
        };
    }, [canvas, options]);
    React.useEffect(() => {
        async function onCodeChange(code, hush = false) {
            if (!synth)
                return;
            if (hush) {
                synth.cameraReset();
                synth.hush();
            }
            const result = await synth.eval(code);
            if (result instanceof Error) {
                setError(result.message);
                return;
            }
            else {
                setError(null);
            }
        }
        onCodeChange(code);
        // on event code-update set code
        function onCodeUpdate(e) {
            const newCode = e.detail.code;
            const hush = e.detail.hush;
            if (newCode) {
                onCodeChange(newCode, hush);
            }
        }
        window.addEventListener("code-update", onCodeUpdate);
        return () => {
            window.removeEventListener("code-update", onCodeUpdate);
        };
    }, [synth, code]);
    const update = React.useMemo(() => {
        return async (selectedNewCode, fullCode = selectedNewCode) => {
            if (!synth)
                return;
            const bEvalAll = selectedNewCode == fullCode;
            if (bEvalAll) {
                updateCode === null || updateCode === void 0 ? void 0 : updateCode(fullCode);
            }
            else {
                const result = await synth.eval(selectedNewCode, false);
                if (result instanceof Error) {
                    setError(result.message);
                    return;
                }
                else {
                    setError(null);
                }
            }
        };
    }, [synth, updateCode]);
    return [synth, error, () => setError(null), update];
}
function useExamples(examples) {
    const [example, setExample] = React.useState();
    const flatExamples = React.useMemo(() => {
        const result = {};
        Object.entries(examples).forEach(([key, value]) => {
            if (typeof value === "string") {
                result[key] = {
                    key,
                    code: value,
                };
            }
            else {
                Object.entries(value).forEach(([subKey, subValue]) => {
                    result[`${key}.${subKey}`] = {
                        key: `${key}.${subKey}`,
                        code: subValue,
                    };
                });
            }
        });
        return result;
    }, [examples]);
    React.useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.has("example")) {
            const exampleKey = params.get("example");
            if (exampleKey && flatExamples[exampleKey]) {
                setExample({ key: exampleKey, code: flatExamples[exampleKey].code.trim() });
            }
            else {
                setExample({
                    key: "",
                    code: "",
                });
            }
        }
        else {
            setExample(undefined);
        }
    }, []);
    function loadExample(newExampleKey) {
        // newExampleKey can be group.subgroup
        const example = flatExamples[newExampleKey];
        if (!example)
            return;
        if (example.key === "noExample") {
            window.location.href = location.pathname;
            return;
        }
        const params = new URLSearchParams(location.search);
        params.set("example", example.key);
        // history.replaceState(null, "", `${location.pathname}?${params.toString()}`)
        window.location.href = `${location.pathname}?${params.toString()}`;
        //setExample({ key: example.key, code: example.code.trim() })
    }
    return [example, loadExample];
}
function useDebug() {
    // check in queryString debug=1
    const [debug, setDebug] = React.useState(false);
    React.useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get("debug") === "1") {
            setDebug(true);
        }
    }, []);
    return debug;
}
